import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCheckboxModule,
	FreudDialogModule,
	FreudDividerModule,
	FreudInputPasswordModule,
	FreudInputTextModule,
	FreudRadioButtonModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ExportModalComponent } from './export-modal.component';

@NgModule({
	declarations: [ExportModalComponent],
	imports: [
		CommonModule,
		FreudDialogModule,
		TranslateModule,
		FreudInputPasswordModule,
		FreudButtonModule,
		FreudRadioButtonModule,
		FreudDividerModule,
		FreudCheckboxModule,
		FreudTooltipModule,
		ReactiveFormsModule,
		FormsModule,
		FreudInputTextModule,
	],
	exports: [ExportModalComponent],
})
export class ExportModalModule {}
